import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { ShoppingBag, Store, ArrowRight, ShieldCheck, Users, TrendingUp } from "lucide-react";

export default function RegisterChoice() {
  const { t } = useLang();

  return (
    <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10 py-10 sm:py-16" data-testid="register-choice">
      <div className="text-center mb-10 sm:mb-14">
        <span className="label-uppercase text-xs text-[#C85A32]">{t("reg.tag")}</span>
        <h1 className="heading font-extrabold text-3xl sm:text-4xl lg:text-5xl mt-3 text-[#111812]">
          {t("reg.title")}
        </h1>
        <p className="mt-4 text-sm sm:text-base text-[#4B5563] max-w-xl mx-auto">
          {t("reg.subtitle")}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6" data-testid="register-choice-cards">
        <Link
          to="/inscription/acheteur"
          className="group bg-white border-2 border-[#1A3322]/10 hover:border-[#1A3322] rounded-2xl p-8 transition-all hover:shadow-lg flex flex-col"
          data-testid="choice-buyer"
        >
          <div className="w-14 h-14 rounded-full bg-[#F5F5F0] flex items-center justify-center mb-6 group-hover:bg-[#1A3322] transition-colors">
            <ShoppingBag className="w-7 h-7 text-[#1A3322] group-hover:text-white transition-colors" />
          </div>
          <h2 className="heading font-extrabold text-2xl text-[#1A3322]">{t("reg.buyer_title")}</h2>
          <p className="text-sm text-[#4B5563] mt-2">{t("reg.buyer_desc")}</p>
          <ul className="mt-6 space-y-2.5 text-sm text-[#111812] flex-1">
            <li className="flex items-start gap-2"><Users className="w-4 h-4 text-[#1A3322] mt-0.5 shrink-0"/>{t("reg.buyer_b1")}</li>
            <li className="flex items-start gap-2"><ShieldCheck className="w-4 h-4 text-[#1A3322] mt-0.5 shrink-0"/>{t("reg.buyer_b2")}</li>
            <li className="flex items-start gap-2"><ShoppingBag className="w-4 h-4 text-[#1A3322] mt-0.5 shrink-0"/>{t("reg.buyer_b3")}</li>
          </ul>
          <Button className="mt-8 pill-btn bg-[#1A3322] hover:bg-[#24472F] rounded-full h-11 group-hover:bg-[#C85A32]" data-testid="choice-buyer-cta">
            {t("reg.buyer_cta")} <ArrowRight className="ml-2 w-4 h-4"/>
          </Button>
        </Link>

        <Link
          to="/inscription/vendeur"
          className="group bg-white border-2 border-[#C85A32]/30 hover:border-[#C85A32] rounded-2xl p-8 transition-all hover:shadow-lg flex flex-col relative overflow-hidden"
          data-testid="choice-seller"
        >
          <div className="absolute top-4 right-4">
            <span className="text-[10px] font-bold px-2.5 py-1 rounded-full bg-[#C85A32] text-white">{t("reg.earn_badge")}</span>
          </div>
          <div className="w-14 h-14 rounded-full bg-[#FFF7ED] flex items-center justify-center mb-6 group-hover:bg-[#C85A32] transition-colors">
            <Store className="w-7 h-7 text-[#C85A32] group-hover:text-white transition-colors" />
          </div>
          <h2 className="heading font-extrabold text-2xl text-[#1A3322]">{t("reg.seller_title")}</h2>
          <p className="text-sm text-[#4B5563] mt-2">{t("reg.seller_desc")}</p>
          <ul className="mt-6 space-y-2.5 text-sm text-[#111812] flex-1">
            <li className="flex items-start gap-2"><Store className="w-4 h-4 text-[#C85A32] mt-0.5 shrink-0"/>{t("reg.seller_b1")}</li>
            <li className="flex items-start gap-2"><TrendingUp className="w-4 h-4 text-[#C85A32] mt-0.5 shrink-0"/>{t("reg.seller_b2")}</li>
            <li className="flex items-start gap-2"><ShieldCheck className="w-4 h-4 text-[#C85A32] mt-0.5 shrink-0"/>{t("reg.seller_b3")}</li>
          </ul>
          <Button className="mt-8 pill-btn bg-[#C85A32] hover:bg-[#D98A2C] rounded-full h-11" data-testid="choice-seller-cta">
            {t("reg.seller_cta")} <ArrowRight className="ml-2 w-4 h-4"/>
          </Button>
        </Link>
      </div>

      <p className="text-center text-sm text-[#4B5563] mt-10">
        {t("reg.already")} <Link to="/connexion" className="text-[#1A3322] font-semibold underline" data-testid="to-login">{t("header.login")}</Link>
      </p>
    </div>
  );
}
